var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.29303 16.7074C9.10556 16.5199 9.00024 16.2656 9.00024 16.0004C9.00024 15.7352 9.10556 15.4809 9.29303 15.2934L12.586 12.0004L9.29303 8.70741C9.11087 8.5188 9.01008 8.2662 9.01236 8.00401C9.01463 7.74181 9.1198 7.491 9.30521 7.30559C9.49062 7.12018 9.74143 7.01501 10.0036 7.01273C10.2658 7.01045 10.5184 7.11125 10.707 7.29341L14.707 11.2934C14.8945 11.4809 14.9998 11.7352 14.9998 12.0004C14.9998 12.2656 14.8945 12.5199 14.707 12.7074L10.707 16.7074C10.5195 16.8949 10.2652 17.0002 10 17.0002C9.73487 17.0002 9.48056 16.8949 9.29303 16.7074Z",
  fill: "#A7B2CD"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-right.18fe074ac707d676a502487476c93cc7.svg";